import type { RezaPermissions } from '@gov-nx/api';
import {
	type PPPStatusTab,
	PPPStatusTabs,
	type PPPTypeTab,
	PPPTypeTabs,
} from './types/tabs/tabs.types';

export const ITEMS_PER_PAGE = 4;

export const REZA_PPP_FORM_PERMISSIONS: RezaPermissions = {
	implicitAllowed: true,
	explicitAllowed: false,
	implicitFilter: [],
	explicitFilter: [],
};
export const DEFAULT_START = 0;

export const ALLOWED_STATUS_BY_TYPE: Record<PPPTypeTab, PPPStatusTab[]> = {
	[PPPTypeTabs.AKTUALNI]: [
		PPPStatusTabs.VSE,
		PPPStatusTabs.PRIJATO,
		PPPStatusTabs.SCHVALENO,
		PPPStatusTabs.ODESLANO_K_DOPRACOVANI,
		PPPStatusTabs.ODESLANO_SPRAVCI,
	],
	[PPPTypeTabs.HISTORIE]: [
		PPPStatusTabs.VSE,
		PPPStatusTabs.ZAMITNUTO,
		PPPStatusTabs.UKONCENO,
	],
};

export const FALLBACK_STATUS_BY_TYPE: Record<PPPTypeTab, PPPStatusTab> = {
	[PPPTypeTabs.AKTUALNI]: PPPStatusTabs.VSE,
	[PPPTypeTabs.HISTORIE]: PPPStatusTabs.VSE,
};
